import { render, staticRenderFns } from "./ServicePoints.vue?vue&type=template&id=21781b4e&scoped=true"
import script from "./ServicePoints.vue?vue&type=script&lang=js"
export * from "./ServicePoints.vue?vue&type=script&lang=js"
import style0 from "./ServicePoints.vue?vue&type=style&index=0&id=21781b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21781b4e",
  null
  
)

export default component.exports